import { X, ShoppingCart, Hash } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ProductDetailModalProps {
  product: any;
  isOpen: boolean;
  onClose: () => void;
  waLink: string;
}

export default function ProductDetailModal({ product, isOpen, onClose, waLink }: ProductDetailModalProps) {
  const { t } = useTranslation();
  
  if (!isOpen || !product) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/95 backdrop-blur-md"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="relative w-full max-w-5xl bg-[#111] rounded-[40px] overflow-hidden border border-white/10 shadow-2xl flex flex-col md:flex-row">
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-6 right-6 z-10 w-12 h-12 flex items-center justify-center bg-black/50 hover:bg-[#F57F25] text-white hover:text-black rounded-full transition-all border-none cursor-pointer"
        >
          <X size={24} />
        </button>

        {/* Image Section */}
        <div className="w-full md:w-1/2 h-[350px] md:h-auto relative">
          <img 
            src={product.image} 
            alt={product.name} 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent md:hidden"></div>
          <div className="absolute bottom-6 left-6 md:hidden">
            <span className="bg-[#F57F25] text-black font-black text-2xl px-5 py-2 rounded-full shadow-lg">
              {product.price}
            </span>
          </div>
        </div>

        {/* Info Section */}
        <div className="w-full md:w-1/2 p-8 md:p-14 flex flex-col justify-center space-y-8">
          <div className="space-y-4">
             <div className="flex items-center gap-2 text-[#F57F25] text-xs font-black uppercase tracking-widest">
               <Hash size={14} />
               <span>SKU: {product.sku || 'N/A'}</span>
             </div>
             <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tighter leading-none">
               {product.name}
             </h2>
             <div className="hidden md:block">
                <span className="text-3xl font-black text-[#F57F25]">{product.price}</span>
             </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-white/30 text-[10px] font-black uppercase tracking-[0.3em]">Description</h4>
            <p className="text-white/60 text-lg leading-relaxed italic">
              "{product.description}"
            </p>
          </div>

          <div className="pt-6">
            <a
              href={product.buyUrl || waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-3 bg-[#F57F25] hover:bg-[#e06d15] text-black font-black py-5 rounded-[24px] transition-all transform hover:scale-[1.02] text-lg uppercase shadow-xl shadow-[#F57F25]/20"
            >
              <ShoppingCart size={24} />
              {t('btn_order_whatsapp')}
            </a>
            <p className="text-center text-white/20 text-[10px] uppercase tracking-widest mt-6">
              * Prices and availability may vary by location
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
